import styles from "./dashboard.module.scss";
import Button from "../../components/button/Button";

import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { Helmet } from "react-helmet";
import ActionsList from "./ActionsList";

import React, { useEffect, useState, useRef } from "react";
import sharedDataApi from "../../api/sharedDataApi";
import { selectUser, selectToast } from "../../app/appSlice";
import { useSelector, useDispatch  } from "react-redux";
import DashboardGridView from "./DashboardGridView.js";
import { FaTh, FaThList } from 'react-icons/fa';
import TablePagination from "../../components/tablePagination/TablePagination";
import { setLoading, setToast } from "../../app/appSlice";
import { useLocation,useNavigate } from "react-router-dom";
import add from "../../assets/images/add.svg";
import AddProductWizard from "../productLists/AddProductWizard/AddProductWizard";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [actionItems, setActionItems] = useState([])
  const [filteredActionItems, setFilteredActionItems] = useState([])
  const [currentPageItems, setCurrentPageItems] = useState([])
  const user = useSelector(selectUser);
  const toast = useSelector(selectToast); // get toast state
  const [searchDisabled, setSearchDisabled] = useState(false);
  const [users, setUsers] = useState([]);
  const [isGridView, setIsGridView] = useState(true);
  const [activeTab, setActiveTab] = useState("incoming");
  const [showSerachBox, setShowSearchBox] = useState(false);
  const [searchText, setSearchText] = useState("")
  const location = useLocation();
  const navigate = useNavigate();

  //Pagination variables
  const [totalResults, setTotalResults] = useState(0);
  const [currPage, setCurrPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const dispatch = useDispatch();

  const fetchRequestRef = useRef(0);

  const actionItemStatus = {
    draft: "DRAFT",
    inReview: "IN_REVIEW",
    approved: "APPROVED",
    rejected: "REJECTED"
  }

  const modals = Object.freeze({
  addProduct: "addProduct",
  none: null,
  });


const [currModal, setCurrModal] = useState(modals.none);

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tabFromUrl = params.get("tab");
  if (tabFromUrl && ["draft", "incoming", "outgoing", "incoolcloudtest", "completed"].includes(tabFromUrl)) {
    setActiveTab(tabFromUrl);
  }
}, []);


  useEffect(() => {
    // Increment request ID for each new fetch
    const currentRequestId = ++fetchRequestRef.current;
    
    const fetchActionItems = async () => {
      setIsLoading(true);

      // Clear previous data immediately when tab changes
      setActionItems([]);
      setFilteredActionItems([]);
      setCurrentPageItems([]);

      const payload = getPayload()

      const updatedPayload = {
        filter: payload,
        initLoad: true,
      };

      let allItems = [];
      let nextToken = null;

    try {
      do {
        // Check if this request is still the current one
          if (currentRequestId !== fetchRequestRef.current) {
            console.log("Request cancelled due to tab change");
            return; // Abort if a newer request has started
          }

        const response = await sharedDataApi.listActionItems({
          ...updatedPayload,
          nextToken: nextToken,
        });

        // Check again after API call completes
          if (currentRequestId !== fetchRequestRef.current) {
            console.log("Request cancelled due to tab change");
            return;
          }

        allItems = [...allItems, ...response.items];
        nextToken = response.nextToken;
      } while (nextToken);

      // Final check before updating state
        if (currentRequestId !== fetchRequestRef.current) {
          console.log("Request cancelled due to tab change");
          return;
        }

      updateSorting("CreationDate", false, allItems);
      setTotalResults(allItems.length);
      onPageChange({ gotoPage: 1 })
      setIsLoading(false);
    } catch (error) {
      // Only handle error if this is still the current request
        if (currentRequestId === fetchRequestRef.current) {
          console.error("Error fetching action items:", error);
          setIsLoading(false);
        }
      }
    };
    fetchActionItems();
    // Cleanup function
    return () => {
      // This will cause the check to fail for any in-flight requests
      // when the effect re-runs (tab changes)
    };
  }, [user, users, activeTab])

  useEffect(() => {
    const fetchUserList = async () => {
      const sdpUserList = await sharedDataApi.listSdpUsers()
      setUsers(sdpUserList.items.map(item => ({
        name: item.Name,
        email: item.Email
      })));
    }
    fetchUserList();
  }, [])

  useEffect(() => {
    const startIndex = (currPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    if(filteredActionItems) {
      setCurrentPageItems(filteredActionItems.slice(startIndex, endIndex));
    }
  }, [currPage, filteredActionItems, itemsPerPage])

  useEffect(() => {
    setSearchDisabled(!!toast?.isOpen && toast?.message === "No result found!");
  }, [toast]);

  const getPayload = () => {
    const payload = {
      and: []
    };

    if (activeTab === "draft") {
      payload.and.push(
        {
          CreatedByEmail: {
            contains: user.email,
          },
        },
        {
          Status: {
            eq: actionItemStatus.draft,
          },
        }
      )
    } 
    else if (activeTab === "incoming") {
      payload.and.push({
        ReviewerEmails: {
          contains: user.email,
        },
      }, {
        or: [
          {
            Status: {
              eq: actionItemStatus.inReview,
            },
          },
          {
            and: [
              {
                Status: {
                  eq: actionItemStatus.approved,
                },
              },
              {
                State: {
                  eq: "Pre_Prod",
                },
              },
            ],
          },
        ],
      })
    } else if (activeTab === "outgoing") {
      payload.and.push({
        CreatedByEmail: {
          contains: user.email,
        },
      }, {
        or: [
          {
            Status: {
              eq: actionItemStatus.inReview,
            },
          },
          {
            and: [
              {
                Status: {
                  eq: actionItemStatus.approved,
                },
              },
              {
                State: {
                  eq: "Staging",
                },
              },
            ],
          },
          {
            and: [
              {
                Status: {
                  eq: actionItemStatus.approved,
                },
              },
              {
                State: {
                  eq: "Pre_Prod",
                },
              },
            ],
          },
        ],
      })
      } else if (activeTab === "incoolcloudtest") {
      payload.and.push(
          {
            or: [
              {
                ReviewerEmails: {
                  contains: user.email,
                },
              },
              {
                CreatedByEmail: {
                  contains: user.email,
                },
              },
            ],
          },
          {
            and: [
              {
                Status: {
                  eq: actionItemStatus.approved,
                },
              },
              {
                State: {
                  eq: "Staging",
                },
              },
            ],
          }
        );
      }
     else {
       payload.and.push(
         {
           or: [
             {
               ReviewerEmails: {
                 contains: user.email,
               },
             },
             {
               CreatedByEmail: {
                 contains: user.email,
               },
             },
           ],
         },
         {
           or: [
             {
               and: [
                 {
                   Status: {
                     eq: actionItemStatus.approved,
                   },
                 },
                 {
                   State: {
                     eq: "Production",
                   },
                 },
               ],
             },
             {
               Status: {
                 eq: actionItemStatus.rejected,
               },
             },
           ],
         }
       );
     }

    return payload
  }

  const onPageChange = (event) => {
    const newPage = event.gotoPage;
    setCurrPage(newPage)

  }

  const onItemsPerPageChange = (itemCount) => {
    setItemsPerPage(itemCount)
    setCurrPage(1)
  }

  // Custom string comparator: 0-9, A-Z, a-z
  function customStringCompare(a, b) {
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
      const charA = a.charAt(i);
      const charB = b.charAt(i);
      if (charA === charB) continue;
      if (!charA) return -1;
      if (!charB) return 1;
      if (isDigit(charA) && !isDigit(charB)) return -1;
      if (!isDigit(charA) && isDigit(charB)) return 1;
      if (isUpper(charA) && isLower(charB)) return -1;
      if (isLower(charA) && isUpper(charB)) return 1;
      if (charA < charB) return -1;
      if (charA > charB) return 1;
    }
    return 0;
  }
  function isDigit(c) { return c >= '0' && c <= '9'; }
  function isUpper(c) { return c >= 'A' && c <= 'Z'; }
  function isLower(c) { return c >= 'a' && c <= 'z'; }

  const updateSorting = (sortKey, sortDirection, actionlist) => {
    let items = []
    if(actionlist && actionlist.length > 0) {
      items = [...actionlist]
    } else {
      items = [...filteredActionItems]
    }

    items = items.sort((a, b) => {
      const valueA = a[sortKey];
      const valueB = b[sortKey];

      if (sortKey === 'LastUpdate' || sortKey === 'CreationDate') {
        const dateA = new Date(valueA);
        const dateB = new Date(valueB);
        return sortDirection ? dateA - dateB : dateB - dateA;
      }

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return sortDirection ? valueA - valueB : valueB - valueA;
      }

      if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
        return sortDirection ? (valueA - valueB) : (valueB - valueA);
      }

      // Custom string sorting: 0-9, A-Z, a-z
      return sortDirection
        ? customStringCompare(String(valueA), String(valueB))
        : customStringCompare(String(valueB), String(valueA));
    });

    setActionItems(items || [])
    setFilteredActionItems(items || [])
    setCurrPage(1); // Reset to page 1 after sorting
  }

  const switchView = () => {
    setIsGridView(!isGridView)
    setCurrPage(1)
  }

  const handleTabClick = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
      setActionItems([]);
      setFilteredActionItems([]);
      setSearchText("")
      setTotalResults(1)
      setCurrPage(1);
    
      const params = new URLSearchParams(location.search);
      params.set("tab", tab);
      navigate({ search: params.toString() }, { replace: true });
    }
  };

  const onDashboardSearch = (e) => {
    const searchText = e.target.value.trim().toLowerCase();
    setSearchText(searchText);
   dispatch(setLoading({ isLoading: true }));
    const filteredItems = actionItems.filter(item => {
      if(item.ModelNumber.toLowerCase().indexOf(searchText) !== -1 || item.Family.toLowerCase().indexOf(searchText) !== -1 || item.SubCategory.toLowerCase().indexOf(searchText) !== -1) {
        return true;
      }
      return false;
    })

    setTotalResults(filteredItems.length)
    setCurrPage(1); // Reset to first page on search
    setFilteredActionItems(filteredItems)
  
    if (filteredItems.length === 0) {
      dispatch(
        setToast({
          isOpen: true,
          message: "No result found!",
          onDismiss: () => dispatch(setToast({ isOpen: false })),
        })
      );
    }
    dispatch(setLoading({ isLoading: false }));
  }

  return (
    <div className={styles.body}>
      <Helmet>
        <title>Shared Data Portal | Dashboard</title>
      </Helmet>
      <div className={styles.pageNameContainer}>
        <div className={styles.pageName}>Dashboard</div>
        <Breadcrumbs />
      </div>
      <div className={styles.list}>
        <div className={styles.listHeader}>
            <Button
              style={styles.addProductButton}
              onClick={() => setCurrModal(modals.addProduct)}
            >
              <img
                className={styles.plusIcon}
                src={add}
                alt="Add Product"
              />
              Add Product
            </Button>
        </div>
        <h2>Action Items</h2>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #e3e1e1', marginBottom: '30px', height: '43px' }}>
          <div className={styles.tabView}>
             <h2
              className={activeTab === "draft" ? styles.active : ""}
              onClick={() => handleTabClick("draft")}
            >
              Draft
            </h2>
            <h2
              className={activeTab === "incoming" ? styles.active : ""}
              onClick={() => handleTabClick("incoming")}
            >
              Received for Review
            </h2>
            <h2
              className={activeTab === "outgoing" ? styles.active : ""}
              onClick={() => handleTabClick("outgoing")}
            >
              Sent for Review
            </h2>
             <h2
              className={activeTab === "incoolcloudtest" ? styles.active : ""}
              onClick={() => handleTabClick("incoolcloudtest")}
            >
              In CoolCloud Test
            </h2>
            <h2
              className={activeTab === "completed" ? styles.active : ""}
              onClick={() => handleTabClick("completed")}
            >
              Completed
            </h2>
          </div>

          <div className={styles.searchAndSwitchViewContainer}>
            {
              showSerachBox ? (
                <div className={styles.data_filter}>
                  <div className={styles.inputIcons}>
                    <form className={styles.search}>
                      <input
                        className={styles.search}
                        type="search"
                        value={searchText}
                        placeholder="Search action items"
                        onChange={(event) => onDashboardSearch(event)}
                        onBlur={() => {
                          if(searchText == "") {
                            setShowSearchBox(false)
                          }
                        }}
                        disabled={searchDisabled}
                      />
                    </form>
                  </div>
                  <div className={styles.buttons}>
                  </div>
                </div>
              ) : <div className={styles.searchIcon} style={{ height: "30px", width: "30px" }} onClick={() => setShowSearchBox(true)}></div>
            }

            <div className={styles.viewIcon} onClick={switchView} title={isGridView ? "Switch to List View" : "Switch to Grid View"}>
              {isGridView ? <FaThList /> : <FaTh />}
            </div>
          </div>
        </div>

        <div>
          {isLoading ? (<h2>Data is loading...</h2>) :
            showSerachBox && searchText && filteredActionItems.length === 0 ? (<h2>No result found</h2>) :
            currentPageItems.length === 0 ? (<h2> No Reviews Pending </h2>) :
              (isGridView ? <DashboardGridView productList={currentPageItems} users={users} updateSorting={updateSorting} activeTab={activeTab} /> : currentPageItems.map((actionItem, index) => (
                <ActionsList key={index} actionItem={actionItem} users={users} activeTab={activeTab} />)))
          }
        </div>
        {currentPageItems.length > 0 && (
          <TablePagination
            total={totalResults}
            currentPage={currPage}
            onPageChange={onPageChange}
            showTotal={false}
            itemsPerPage={itemsPerPage}
            items={"actionItemList"}
            onItemsPerPageChange={onItemsPerPageChange}
          />
        )}
      </div>
      {currModal === modals.addProduct && (
        <AddProductWizard
          onAbort={() => setCurrModal(modals.none)}
        />
      )}

    </div>
  )
}

export default Dashboard;